export var PUBLIC_VOD_DISABLED_PUSHER_EVENT = "App\\Events\\PublicVodDisabledEvent";
/**
 * `App\Events\PublicVodDisabledEvent` is broadcast on the *public* channel
 * `{appId}.none` (no `presence-` / `private-` prefix), unlike the other App
 * events which ride the presence channel — so it needs its own subscription.
 */
export var subscribeToPublicVodChannel = function (_a) {
    var pusherSingleton = _a.pusherSingleton, appId = _a.appId, onVodDisabled = _a.onVodDisabled;
    if (!pusherSingleton)
        return null;
    try {
        var channel = pusherSingleton.subscribe("".concat(appId, ".none"));
        channel.bind(PUBLIC_VOD_DISABLED_PUSHER_EVENT, onVodDisabled);
        return channel;
    }
    catch (e) {
        console.warn("Error while subscribing to the public VOD channel: ", e);
        return null;
    }
};
